<template>
  <b-dropdown position="is-bottom-right" aria-role="list" class="color-selector">
    <template #trigger="{ active }">
      <b-button :icon-right="active ? 'chevron-up' : 'chevron-down'" icon-pack="fas" class="trigger-button">
        <ColorSwatch :theme="value" />
      </b-button>
    </template>
    <b-dropdown-item @click="updateColorTheme(theme)" v-for="theme in colorThemes" :key="theme.name" aria-role="listitem">
      <ColorSwatch :theme="theme" :class="{'is-active': value.colors && theme.name === value.name}" />
    </b-dropdown-item>
  </b-dropdown>
</template>
<script>
import { colorThemes } from '~/common/themeData'
import ColorSwatch from '~/components/modals/deck-settings-modal/color-selector/ColorSwatch'

export default {
  name: 'ColorSelector',
  components: { ColorSwatch },
  props: [
    'value'
  ],
  computed: {
    colorThemes () {
      return colorThemes
    }
  },
  methods: {
    updateColorTheme (theme) {
      this.$emit('input', theme)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~~/assets/css/components";

.color-selector {
  @include dropdown-selector;

  a.dropdown-item {
    padding-right: 1rem;
  }

  .color-swatch.is-active {
    border-color: $secondary;
  }
}
</style>
